import type {
  CardTotals,
  ColumnTotals,
  ScoreColumn,
  Scorecard,
  VariantDef,
} from './types';

export function blankColumn(variant: VariantDef): ScoreColumn {
  const boxes: Record<string, number | null> = {};
  for (const c of variant.categories) boxes[c.id] = null;
  return { boxes, fiveKindBonuses: 0 };
}

export function blankCard(variant: VariantDef): Scorecard {
  return { cols: variant.columns.map(() => blankColumn(variant)) };
}

export function columnTotals(
  col: ScoreColumn,
  variant: VariantDef,
  colIndex: number
): ColumnTotals {
  let upper = 0;
  let lower = 0;
  const upperSet = new Set(variant.upperCategoryIds);
  for (const c of variant.categories) {
    const v = col.boxes[c.id];
    if (v == null) continue;
    if (upperSet.has(c.id)) upper += v;
    else lower += v;
  }
  const upperBonus = variant.upperBonus(upper);
  const fiveKindBonus = variant.fiveKind
    ? col.fiveKindBonuses * variant.fiveKind.bonus
    : 0;
  const raw = upper + upperBonus + lower + fiveKindBonus;
  const multiplier = variant.columns[colIndex] ?? 1;
  return {
    upper,
    upperBonus,
    lower,
    fiveKindBonus,
    raw,
    multiplier,
    total: raw * multiplier,
  };
}

export function cardTotals(card: Scorecard, variant: VariantDef): CardTotals {
  const cols = card.cols.map((c, i) => columnTotals(c, variant, i));
  let filled = 0;
  for (const c of card.cols)
    for (const v of Object.values(c.boxes)) if (v != null) filled++;
  return {
    cols,
    grand: cols.reduce((a, c) => a + c.total, 0),
    filled,
    boxes: variant.categories.length * card.cols.length,
  };
}

export function isCardFull(card: Scorecard): boolean {
  return card.cols.every(c => Object.values(c.boxes).every(v => v != null));
}

export function openBoxes(col: ScoreColumn): string[] {
  return Object.entries(col.boxes)
    .filter(([, v]) => v == null)
    .map(([k]) => k);
}
